export default "__VITE_ASSET__DNlPzzyh__"